import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { WatchIconButton, WatchConnectedDot } from './index.styled'
import { selectWatchConnected } from '../../../redux/selector/watch'
import { setWatchDrawerOpen } from '../../../redux/action/watch'
import { fetchWatchesThunk } from '../../../redux/thunk/watch'
import WatchSvg from '../../../img/svg/watch'

const WatchIcon = () => {
	const dispatch = useDispatch()
	const connected = useSelector(selectWatchConnected)

	useEffect(() => {
		dispatch(fetchWatchesThunk())
	}, [dispatch])

	const handleClick = () => {
		dispatch(setWatchDrawerOpen(true))
	}

	return (
		<WatchIconButton
			data-testid="watch-icon-button"
			className={connected ? 'connected' : ''}
			onClick={handleClick}
		>
			<WatchSvg icon="clock" />
			{connected && <WatchConnectedDot data-testid="watch-connected-dot" />}
		</WatchIconButton>
	)
}

WatchIcon.displayName = 'WatchIcon'
export default WatchIcon
